import {Platform} from 'react-native';
import {AppDispatch} from '../../redux';
import {setRuntimeLoginStepState} from '../../redux/actions/runtime/loginStep';
import {loginSlice} from '../../redux/reducers/login';
import {LoginState} from '../models/login/loginStep';
import {clearCardReissueEsiaPending, isCardReissueEsiaPending} from '../storage/cardReissueEsia';
import {hasEsiaOAuthParams} from '../utils/esiaOAuthParams';
import {hideGlobalLoader} from '../utils/globalLoader';

export const subscribeEsiaBrowserBack = (dispatch: AppDispatch, getLoginStep: () => LoginState) => {
  if (Platform.OS !== 'web') return;

  const onPageShow = (event: PageTransitionEvent) => {
    if (!event.persisted || hasEsiaOAuthParams()) return;
    // The callback document may have cleared sessionStorage while this document was cached.
    if (getLoginStep() !== LoginState.esiaLogin && !isCardReissueEsiaPending()) return;

    void clearCardReissueEsiaPending();
    dispatch(loginSlice.actions.resetEsiaFlow(null));
    dispatch(setRuntimeLoginStepState(LoginState.enter));
    hideGlobalLoader({resetBlockingCalls: true});
  };

  window.addEventListener('pageshow', onPageShow);
  return () => window.removeEventListener('pageshow', onPageShow);
};
